import { useEffect } from "react";
import { useSettingsSearch } from "./SettingsSearchContext";
import { sectionMatchesSearch } from "../data/settingsSearchIndex";
import { resolveSettingsNav } from "../data/settingsNavConfig";

/** When searching, jump to the first matching section in the nav. */
export default function SettingsSearchSync({
  activeSection,
  setActiveSection,
  showProgressionAdmin,
  /** Mobile catalog already filters the list — skip auto-jump there. */
  skipAutoJump = false,
}) {
  const { normalizedQuery } = useSettingsSearch();

  useEffect(() => {
    if (!normalizedQuery || skipAutoJump) return;
    const groups = resolveSettingsNav({ showProgressionAdmin });
    for (const group of groups) {
      for (const item of group.items) {
        if (sectionMatchesSearch(item.id, item.title, normalizedQuery)) {
          if (activeSection !== item.id) setActiveSection(item.id);
          return;
        }
      }
    }
  }, [
    normalizedQuery,
    showProgressionAdmin,
    activeSection,
    setActiveSection,
    skipAutoJump,
  ]);

  return null;
}
